const appInfo =  {
    appName: {
        'com.wifi.reader': {
            channel: '',
            package: 'com.wifi.reader',
            'version-code': 211208,
            appName: '连尚读书'
        }, // 主板
        'com.wifi.reader.free': {
            channel: '',
            package: 'com.wifi.reader.free',
            'version-code': 211208,
            appName: '连尚读书免费版'
        }, // 免费
        'com.wifi.reader.lite': {
            channel: '',
            package: 'com.wifi.reader.lite',
            'version-code': 211208,
            appName: '连尚读书极速版'
        }, // 极速版
        'com.wifi.reader.girl': {
            channel: '',
            package: 'com.wifi.reader.girl',
            'version-code': 211208,
            appName: '连尚读书女生版'
        }, // 女生版
        'com.snda.lantern.wifilocating': {
            channel: 'SDK_WIFI',
            package: 'com.snda.lantern.wifilocating',
            sdk: 'wifilite',
            'version-code': 211208
        }, // 钥匙极速版
        'com.snda.wifilocating': {
            channel: 'SDK_WIFI',
            package: 'com.snda.wifilocating',
            sdk: 'wifi',
            'version-code': 211208
        }, // 钥匙主板
        'com.ios.lsnovel.wifi001': {
            channel: 'sdk_ioswifi001',
            package: 'com.ios.lsnovel.wifi001',
            sdk: 'wifi',
            'version-code': 220310
        }
    },
    schemeValue: {
        'jinshu': {
            name: '锦书',
            value: 'jinshu'
        },
        'wangshu': {
            name: '网书',
            value: 'wangshu'
        },
        'reader': {
            name: '连尚读书',
            value: 'reader'
        },
        'free': {
            name: '连尚读书免费版',
            value: 'free'
        },
        'lite': {
            name: '连尚读书极速版',
            value: 'lite'
        },
        'girl': {
            name: '连尚读书女生版',
            value: 'girl'
        }
    },
}

export default appInfo


// WEBPACK FOOTER //
// ./src/common/js/info.js